<template>
  <v-container class="acesso-por-usuario">
    <v-card flat>
      <v-row>
        <v-col
          cols="12"
          lg="3"
          md="4"
        >
          <v-container>
            <v-treeview
              :items="items"
              open-on-click
              hoverable
            >
              <template
                slot="label"
                slot-scope="{ item }"
              >
                <div @click="loadUserView(item, mode = 'insere')">{{ item.name }}</div>
              </template>
            </v-treeview>
          </v-container>
        </v-col>
        <v-col
          cols="12"
          lg="9"
          md="8"
        >
          <v-card
            class="px-2"
            flat
          >
            <input
              id="user-id"
              type="hidden"
              v-model="view.usuario"
            >
            <input
              id="view-id"
              type="hidden"
              v-model="view.id"
            >
            <v-row>
              <v-col
                cols="12"
                md="3"
                lg="3"
              >
                <v-text-field
                  v-model="codigo"
                  label="Código"
                  dense
                  outlined
                  @change="loadGrupo()"
                >
                  <v-btn
                    class="btn-outer-right pa-0"
                    slot="append"
                    color="success"
                    tile
                    @click.prevent="loadDialog"
                  >
                    <v-icon
                      class="mx-0"
                      color="white"
                    >
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="5"
                lg="5"
                sm="6"
              >
                <v-card-text class="py-0 mt-0">Usuário:<h4>{{ userName }}</h4>
                </v-card-text>
              </v-col>
              <v-col
                cols="12"
                md="4"
                lg="4"
              >
                <v-spacer></v-spacer>
                <v-btn
                  color="success"
                  class="ml-1 mb-3"
                  v-if="codigo"
                  @click="loadModalModulo"
                >
                  <v-icon left>
                    mdi-archive-arrow-up-outline
                  </v-icon>
                  add Módulos
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="py-2">
            <v-data-table
              :headers="headerModulos"
              :items="modulos"
              fixed-header
              height="300px"
              dense
              class="elevation-1"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  size="24"
                  color="success"
                  class="mr-2"
                  @click="loadViews(item, mode='updateM')"
                >
                  mdi-arrow-left-bold-box
                </v-icon>
                <v-icon
                  size="24"
                  color="success"
                  class="mr-2"
                  @click="loadMOrdem(item, mode='updateM')"
                >
                  mdi-square-edit-outline
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
          <v-card class="py-2 px-2 borda-vm">
            <input
              id="user-id"
              type="hidden"
              v-model="userview.usuario"
            >
            <input
              id="user-modulo"
              type="hidden"
              v-model="userview.uid_user"
            >
            <input
              id="uid_view"
              type="hidden"
              v-model="userview.uid_view"
            >
            <input
              id="modulo"
              type="hidden"
              v-model="userview.program"
            >
            <input
              id="view-id"
              type="hidden"
              v-model="userview.id"
            >
            <v-row>
              <v-col
                cols="12"
                md="3"
                lg="2"
                class="px-1 mx-1"
              >Módulo<br />{{ moduloName }}</v-col>
              <v-col class="px-1 mx-1">
                <v-checkbox
                  v-model="userview.menu"
                  label="Memu"
                  color="success"
                  class="mt-4"
                >
                </v-checkbox>
              </v-col>
              <v-col class="px-1 mx-1">
                <v-checkbox
                  v-model="userview.acessar"
                  label="Acessar"
                  color="success"
                  class="mt-4"
                >
                </v-checkbox>
              </v-col>
              <v-col class="px-1 mx-1">
                <v-checkbox
                  v-model="userview.gravar"
                  label="Gravar"
                  color="success"
                  class="mt-4"
                >
                </v-checkbox>
              </v-col>
              <v-col class="px-1 mx-1">
                <v-checkbox
                  v-model="userview.atualizar"
                  label="Atualizar"
                  color="success"
                  class="mt-4"
                >
                </v-checkbox>
              </v-col>
              <v-col class="px-1 mx-1">
                <v-checkbox
                  v-model="userview.deletar"
                  label="Deletar"
                  color="success"
                  class="mt-4"
                >
                </v-checkbox>
              </v-col>
              <v-col class="px-1 mx-1">
                <v-icon
                  large
                  color="success"
                  class="mt-3"
                  v-show="mode === 'insere'"
                  @click.prevent="saveUsView()"
                  left
                >
                  mdi-arrow-right-bold-box
                </v-icon>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="py-2">
            <v-data-table
              :headers="headerViews"
              :items="userviews"
              fixed-header
              height="200px"
              dense
              hide-default-footer
              class="elevation-1"
            >
              <template v-slot:[`item.menu`]="{ item }">
                <v-checkbox
                  v-model="item.menu"
                  color="success"
                  dense
                  style="height: 30px;"
                >
                </v-checkbox>
              </template>
              <template v-slot:[`item.acessar`]="{ item }">
                <v-checkbox
                  v-model="item.acessar"
                  color="success"
                  dense
                  style="height: 30px;"
                >
                </v-checkbox>
              </template>
              <template v-slot:[`item.gravar`]="{ item }">
                <v-checkbox
                  v-model="item.gravar"
                  color="success"
                  dense
                  style="height: 30px;"
                >
                </v-checkbox>
              </template>
              <template v-slot:[`item.atualizar`]="{ item }">
                <v-checkbox
                  v-model="item.atualizar"
                  color="success"
                  dense
                  style="height: 30px;"
                >
                </v-checkbox>
              </template>
              <template v-slot:[`item.deletar`]="{ item }">
                <v-checkbox
                  v-model="item.deletar"
                  color="success"
                  dense
                  style="height: 30px;"
                >
                </v-checkbox>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-card>
      <v-dialog
        v-model="dialogGrupos"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialogGrupos">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar grupos de modulos
            </v-toolbar>
            <v-card-title>
              <v-card-title>
                Pesquisar
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Filtrar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
            </v-card-title>
            <v-data-table
              :headers="headersGrupos"
              :items="grupos"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  large
                  color="success"
                  class="mr-2"
                  @click="loadGrupo(item, mode = 'save')"
                >
                  mdi-arrow-down-bold-box
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialogGrupos.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-card>
    <v-card>
      <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar usuarios cadastradas
            </v-toolbar>
            <v-card-title>
              <v-card-title>
                Pesquisar
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Filtrar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="filtro"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  large
                  color="success"
                  class="mr-2"
                  @click="loadPessoaFilter(item)"
                >
                  mdi-arrow-down-bold-box
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialog.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-card>
    <!-- Dialog de adicionar grupo -->
    <v-container>
      <v-dialog
        v-model="dialogAddModulos"
        transition="dialog-top-transition"
      >
        <v-card tile>
          <v-toolbar
            color="primary"
            dark
            class="mb-2"
          >
            Adicionar módulos ao usuário
          </v-toolbar>
          <div class="ml-4 mt-5">
            <v-form>
              <input
                id="usuario"
                type="hidden"
                v-model="modulo.usuario"
              />
              <input
                id="uuid-id"
                type="hidden"
                v-model="modulo.uid_user"
              />
              <input
                id="modulo-id"
                type="hidden"
                v-model="modulo.id"
              />
              <v-row>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="codigo"
                    label="Código"
                    dense
                    outlined
                    @change="loadModuloAdd()"
                  >
                    <v-btn
                      class="btn-outer-right pa-0"
                      slot="append"
                      color="success"
                      tile
                      @click.prevent="loadDialogGrupo"
                    >
                      <v-icon
                        class="mx-0"
                        color="white"
                      >
                        mdi-magnify
                      </v-icon>
                    </v-btn>
                  </v-text-field>
                </v-col>
                <v-col
                  colls="12"
                  lg="3"
                  md="4"
                >
                  <v-checkbox
                    v-model="modulo.acessar"
                    label="Acessar ?"
                    color="success"
                    class="mt-4"
                  >
                  </v-checkbox>
                </v-col>
                <v-col
                  colls="12"
                  lg="3"
                  md="4"
                  v-if="modulo.id"
                >
                  <v-checkbox
                    v-model="modulo.inativar"
                    label="Inativar este ítem?"
                    color="success"
                    class="mt-4"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="8"
                  lg="7"
                >
                  <v-text-field
                    v-model="modulo.modulo"
                    type="text"
                    label="Módulo"
                    outlined
                    dense
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <v-card-actions class="justify-end">
            <v-btn
              color="success"
              class="mr-4"
              type="submit"
              v-show="mode === 'updateM'"
              @click.prevent="saveMod()"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Atualizar
            </v-btn>
            <v-btn
              color="success"
              class="mr-4"
              v-show="mode === 'save'"
              type="submit"
              @click.prevent="saveMod()"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="danger"
              class="mr-4"
              @click="FecharDialog"
            >
              <v-icon left>
                mdi-close-box-outline
              </v-icon>
              Sair
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'AcessoPorUsuario',
  computed: mapState(['user']),
  data: () => ({
    dialog: false,
    dialogGrupos: false,
    dialogAddModulos: false,
    codigo: '',
    mode: 'save',
    search: '',
    userName: '[Usuário não selecionado]',
    moduloName: '[Não informado]',
    view: {},
    usuario: {},
    userview: {},
    modulo: {},
    items: [],
    filtro: [],
    modulos: [],
    userviews: [],
    grupos: [],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'E-mail', value: 'email' },
      { text: 'Cpf / Cgc', value: 'cgc_txt' },
      { text: 'Rg', value: 'rg' },
      { text: 'Nis', value: 'nis' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headerModulos: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Módulo', value: 'modulo' },
      { text: 'Acessar', value: 'acesso' },
      { text: 'Tipo', value: 'uid_tipo' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headerViews: [
      {
        text: 'Módulo',
        align: 'start',
        sortable: false,
        value: 'program'
      },
      { text: 'Menu', value: 'menu', sortable: false },
      { text: 'Acessar', value: 'acessar', sortable: false },
      { text: 'Gravar', value: 'gravar', sortable: false },
      { text: 'Atualizar', value: 'atualizar', sortable: false },
      { text: 'Deletar', value: 'deletar', sortable: false }
    ],
    headersGrupos: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Módulo', value: 'nome' },
      { text: 'Descrição', value: 'ds_grupo' },
      { text: 'Ações', value: 'actions', sortable: false }
    ]
  }),
  methods: {
    save () {

    },
    saveMod () {
      const method = this.modulo.id ? 'put' : 'post'
      const id = this.modulo.id ? `/${this.modulo.id}` : ''
      axios[method](`${baseApiUrl}/modulos-do-usuario${id}`, this.modulo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },
    saveUsView () {
      const method = this.userview.id ? 'put' : 'post'
      const id = this.userview.id ? `/${this.userview.id}` : ''
      const grupo = this.userview.program
      axios[method](`${baseApiUrl}/userview-dos-modulos${id}`, this.userview)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetNode()
        })
        .catch(showError)
      this.loadUserViews(grupo)
    },
    reset () {
      this.mode = 'save'
      this.userName = '[Usuário não selecionado]'
      this.moduloName = '[Não informado]'
      this.items = []
      this.codigo = ''
    },
    resetNode () {
      this.moduloName = '[Não informado]'
      this.userview = {}
    },
    loadGrupo (item, mode) {
      const id = item.id
      this.mode = mode
      const url = `${baseApiUrl}/menu-grupo-modulo-add/${id}`
      axios.get(url).then(res => {
        this.modulo = res.data
        this.modulo.uid_user = this.usuario.id
        this.modulo.usuario = this.user.id
      })
      this.dialogGrupos = false
    },
    loadDialog () {
      this.dialog = true
      this.loadFiltro()
    },
    loadDialogGrupo () {
      this.dialogGrupos = true
      this.loadFiltroGrupos()
    },
    loadFiltroGrupos () {
      const url = `${baseApiUrl}/menu-sys-admin`
      axios.get(url).then(res => {
        this.grupos = res.data
      })
    },
    loadModuloAdd () {

    },
    loadModalModulo () {
      this.dialogAddModulos = true
      this.modulo.usuario = this.user.id
    },
    FecharDialog () {
      this.dialogAddModulos = false
    },
    loadUserView (item, mode) {
      this.mode = mode
      const id = item.id
      const url = `${baseApiUrl}/views-dos-modulos-list/${id}`
      axios.get(url).then(res => {
        this.view = res.data
        this.moduloName = this.view.ds_view
        this.userview.usuario = this.user.id
        this.userview.uid_user = this.usuario.id
        this.userview.uid_view = this.view.uid_view
        this.userview.program = this.view.program
      })
    },
    loadViews (item) {
      const id = item.uid_group
      const grupo = item.uid_group
      const url = `${baseApiUrl}/menu-grupo-modulo-list/${id}`
      axios.get(url).then(res => {
        this.items = res.data
      })
      this.loadUserViews(grupo)
    },
    loadFiltroModulos (cod) {
      const id = cod
      const url = `${baseApiUrl}/modulos-do-usuario-list/${id}`
      axios.get(url).then(res => {
        this.modulos = res.data.map(item => {
          return {
            ...item,
            acesso: item.acessar === 0 ? 'Não' : 'Sim'
          }
        })
      })
    },
    loadUserViews (grupo) {
      const uid = this.usuario.id
      const id = grupo
      const url = `${baseApiUrl}/userview-dos-modulos-list/${id}/user?uid=${uid}`
      axios.get(url).then(res => {
        this.userviews = res.data
      })
    },
    loadFiltro () {
      const url = `${baseApiUrl}/usuarios`
      axios.get(url).then(res => {
        this.filtro = res.data
      })
    },
    loadPessoaFilter (filtro, mode = 'save') {
      this.codigo = filtro.id
      const id = filtro.uuid
      this.mode = mode
      const url = `${baseApiUrl}/usuarios/${id}`
      axios.get(url).then(res => {
        this.usuario = res.data
        const cod = this.usuario.id
        this.userName = this.usuario.nome
        this.usuario.data_senha = moment(this.usuario.data_senha).format('YYYY-MM-DD')
        this.dialog = false
        this.loadFiltroModulos(cod)
      })
    },
    loadUser () {
    }
  },
  created () {
    this.loadUser()
  }
}
</script>
<style scoped>
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.v-size--default {
  height: 37px !important;
  min-width: 38px !important;
}
</style>
